<template>
    <div>
        <button v-if="$can('avance-forzar-edicion')" type="button" class="btn btn-warning btn-sm" v-on:click="onClick">Modificar</button>
    </div>
</template>

<script>
    export default {
        name: "delete-button",
        methods:{
            onClick(){
                this.params.context.componentParent.modificarAvance(this.params.data);
            }
        }
    }
</script>

<style scoped>

</style>